module.exports = __webpack_public_path__ + "static/media/country_sx.c157ea95.webp";